import { render, staticRenderFns } from "./BlueCircles.vue?vue&type=template&id=01c86a71&scoped=true&"
var script = {}
import style0 from "./BlueCircles.vue?vue&type=style&index=0&id=01c86a71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c86a71",
  null
  
)

export default component.exports